//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const FormSearchSuggestions: FeatureFlag = {"Id":"FormSearchSuggestions","Label":"[10.27] Show \"Did you mean\" search suggestions","Impact":"Shows a \"Did you mean\" suggestion in the nav search modal when the search text closely matches a form's label, tags, keywords, or description.","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
